import { bool, object } from 'prop-types';
import React from 'react';
import style from './Pagination.module.scss';
import { usePaginationContext } from './PaginationContainer';
import Icon from '../Icon';
import Loader from '../Loader';

const PAGE_START_INDEX = 1;
const NUMBER_COUNT = 5;

const Pagination = ({ loading, pagination: paginationProp }) => {
  const paginationCtx = usePaginationContext();
  const { pageCount, page, gotoPage } = paginationProp || paginationCtx;

  function handleChangePage(n) {
    if (n >= PAGE_START_INDEX && n <= pageCount && n !== page) {
      gotoPage(n);
    }
  }

  const items = [];

  let startPage = Math.max(page - Math.floor(NUMBER_COUNT / 2), PAGE_START_INDEX);
  let endPage = startPage + NUMBER_COUNT - 1;

  if (endPage > pageCount) {
    endPage = pageCount;
    startPage = endPage - NUMBER_COUNT + 1;
  }

  for (let i = startPage; i <= endPage; i += 1) {
    if (i < PAGE_START_INDEX) continue;

    if (i === page) {
      items.push(
        <button
          key={i}
          type="button"
          className={style.selectedPaginationButton}
          onClick={() => handleChangePage(i)}
        >
          {loading ? <Loader size={15} /> : `Page ${i} / ${pageCount}`}
        </button>,
      );
    } else {
      items.push(
        <button
          key={i}
          type="button"
          className={style.paginationButton}
          onClick={() => handleChangePage(i)}
        >
          {i}
        </button>,
      );
    }
  }

  return pageCount > 1 ? (
    <div className={style.pagination}>
      <button type="button" className={style.paginationTextButton} onClick={() => gotoPage(1)}>
        <span>First</span>
      </button>
      <button
        type="button"
        className={style.paginationButton}
        onClick={() => handleChangePage(page - 1)}
        aria-label="previous"
      >
        <Icon name="chevron-left" size={14} />
      </button>
      {items}
      <button
        type="button"
        className={style.paginationButton}
        onClick={() => handleChangePage(page + 1)}
        aria-label="next"
      >
        <Icon name="chevron-right" size={14} />
      </button>
      <button
        type="button"
        className={style.paginationTextButton}
        onClick={() => handleChangePage(pageCount)}
      >
        <span>Last</span>
      </button>
    </div>
  ) : null;
};

export default Pagination;

Pagination.propTypes = {
  loading: bool,
  pagination: object,
};
